<style scoped>
  .mui-calendar-hd{
    background: #ddd;
    border-radius: 10px 10px 0 0;
    padding:10px 20px;
    line-height: 30px;
    text-align: center;
    border:1px solid #ccc;
    border-bottom:none;
    position: relative;
  }
  .mui-calendar-hd .icon{color:#333;font-size:20px}
  .mui-calendar-bd{
    border-right:1px solid #ccc;
    border-bottom:1px solid #ccc;
    font-size:16px;
    color:#666
  }
  .mui-calendar-bd .money span{color:#f60}
  .mui-calendar-bd .month{font-size: 18px;margin-bottom:10px;color:#999}
  .mui-calendar-bd .col{border-left:1px solid #ccc;border-top:1px solid #ccc;padding:15px 20px}
  .mui-calendar-fd{
    background: #eee;
    border-radius: 0 0 10px 10px;
    padding:10px 20px;
    line-height: 30px;
    text-align: center;
    border:1px solid #ccc;
    border-top:none;
    font-size:18px
  }
</style>
<template>
  <div>
    <!-- <div class="filter-row" style="text-align:right">
      日期：<DatePicker v-model="yearMonth" type="daterange" style="width:200px" placeholder="选择日期"></DatePicker>
      <Button icon="ios-search">筛选</Button>
      <span style="color:#999;padding:0 10px;">|</span>
      <Button icon="ios-cloud" type="primary" @click="addFormModal=true">上传数据</Button>
    </div> -->
    <div class="mui-calendar">
      <div style="padding:0 0 10px">
      </div>
      <div class="mui-calendar-hd">
        <!-- <a href="javascript:void(0)" @click="year = year + 1" style="font-size:20px;color:#fff">
          <Icon type="ios-arrow-back" class="icon" style="float:left"/>
        </a>
        <a href="javascript:void(0)" @click="year = year - 1" style="font-size:20px;color:#fff">
          <Icon type="ios-arrow-forward" class="icon" style="float:right"/>
        </a> -->
        <div style="float:right;">
          <!-- 项目： -->
          <!-- <Select v-model="projectIndex" style="width:160px;text-align:left" @on-change="projectChange" placehol="请选择项目">
            <Option v-for="(item, index) in projects" :value="index" :key="index">{{item.project}}</Option>
          </Select> -->
        </div>
        <div style="position:absolute;z-index:1">
          部门：
          <Select v-model="department" style="width:160px;text-align:left" @on-change="departmentChange">
            <Option v-for="(item, index) in departmentGroup" :value="item.id" :key="index">{{item.name}}</Option>
          </Select>
        </div>
        <DatePicker :open="pickerOpen" @on-ok="pickerOk" :clearable="false" v-model="year" type="year" style="width:200px" confirm>
          <a href="javascript:void(0)" @click="selectPicker" style="font-size:20px;border-bottom:1px solid #2d8cf0">
            <Icon type="calendar"/>
            <template v-if="year === ''">Select Year</template>
            <template v-else>{{ year | formatYear }} 年</template>
          </a>
        </DatePicker>
      </div>
      <Row class="mui-calendar-bd">
          <template v-for="(result, index) in results">
        <Col span="24" class="col" :key="index">
          <h4 :key="'title'+index" style="margin-bottom:10px"><span style="color:#ccc">[{{result.year}}]</span> {{result.project}}</h4>
          <Row :key="result.id" style="border-bottom:1px solid #eee;" :gutter="10" v-if="results.length > 0">
            <Col :span="4" v-for="(month) in 12" :key="month">
            <Card style="height:100px;margin-bottom:10px">
              <h6 style="border-bottom:1px solid #ddd;margin-right:20px;">
                <p style="font-size:12px;float:right;margin-right:5px">
                  <a href="javascript:void(0);" style="float:right;font-size:12px" @click="editMoney(index, month)" v-if="result.children && getMoney(index, month)">
                    <Icon type="edit" /> 编辑
                  </a>
                  <a href="javascript:void(0);" style="float:right;font-size:12px" class="tag" @click="addMoney(result.id, month)" v-else>
                    <Icon type="plus" /> 添加
                  </a>
                </p>
                {{month}} 月
              </h6>
              <div class="money" v-if="result.children && getMoney(index, month)">
                  <i style="font-size:12px">¥</i> <span>{{getMoney(index, month)}}</span> <span style="font-size:12px">元</span>
                  <Poptip placement="bottom" title="明细" width="400" style="text-align:left;">
                    <Icon type="android-arrow-dropdown-circle" color="#999"></Icon>
                    <div slot="content">
                      <ul>
                        <li v-for="sub in getSub(index, month)" :key="sub.id" style="border-bottom:1px solid #eee;padding:5px 0">
                          <span style="float:right;color:#999;font-size:12px;">{{sub.updated_at}}</span>
                          {{sub.day}} 日 到账：￥{{sub.money}}
                        </li>
                      </ul>
                    </div>
                  </Poptip>
                </div>
            </Card>
            </Col>
          <!-- <div class="month">{{month}} <span style="font-size:12px">月</span></div> -->
            <!-- <Col span="21" style="" v-for="(month, ind) in 12">
              <p style="font-size:12px;">
                <a href="javascript:void(0);" style="float:right;font-size:12px" @click="editMoney(index, month)" v-if="result.children && getMoney(index, month)">
                  <Icon type="edit" /> 编辑
                </a>
                <a href="javascript:void(0);" style="float:right;font-size:12px" class="tag" @click="addMoney(result.id, month)" v-else>
                  <Icon type="plus" /> 添加
                </a>
              </p>
              <p style="text-align:right;padding: 5px 0 0">
                <span class="money" v-if="result.children && getMoney(index, month)">
                  <i style="font-size:12px">¥</i> <span>{{getMoney(index, month)}}</span> <span style="font-size:12px">元</span>
                  <Poptip placement="bottom" title="明细" width="400" style="text-align:left;">
                    <Icon type="android-arrow-dropdown-circle" color="#999"></Icon>
                    <div slot="content">
                      <ul>
                        <li v-for="sub in getSub(index, month)" :key="sub.id" style="border-bottom:1px solid #eee;padding:5px 0">
                          <span style="float:right;color:#999;font-size:12px;">{{sub.updated_at}}</span>
                          {{sub.day}} 日 到账：￥{{sub.money}}
                        </li>
                      </ul>
                    </div>
                  </Poptip>
                </span>
                <span style="color:#ccc" v-else>--</span>
              </p>
            </Col> -->
          </Row>
          <div style="text-align:center" :key="index" v-else>
             <span style="font-size:12px;">-- 还未添加项目 --</span>
          </div>
            总计：{{result.total | toMoney}}

        </Col>
          </template>
      </Row>
      <div class="mui-calendar-fd" v-if="results.length > 0">
        <!-- <Row v-for="result in results" :key="result.id" style="font-size:14px;border-bottom:1px solid #eee;text-align:left">
          <Col span="12" style="text-align:right">
            【{{result.project}}】 总计：
          </Col>
          <Col span="12">{{result.total | toMoney}}</Col>
        </Row> -->
        <Row style="font-size:14px;text-align:left;border-top:1px solid #ddd;">
          <Col span="12" style="text-align:right">合计：</Col>
          <Col span="12">{{countMoney() | toMoney}}</Col>
        </Row>
        <!-- 总计：{{results[0].total | toMoney}} -->
      </div>
    </div>
    <Modal
      title="上传数据"
      v-model="formModal"
      @on-ok="addForm"
      @on-visible-change="modalVisibleChange"
      >
      <Form ref="reportForm" :model="form" :rules="ruleFormValidate" :label-width="80">
        <FormItem label="时间" prop="year_month">
          <Tag>{{form.year_month}}</Tag>
          <!-- <DatePicker type="month" v-model="form.year_month" @on-change="dateChange" placeholder="请选择年月" style="width: 380px"></DatePicker> -->
        </FormItem>
        <!-- <FormItem label="项目" prop="report_project_id"> -->
          <!-- <Select v-model="form.report_project_id" style="width:200px"> -->
              <!-- <Tag v-for="item in projects" v-if="form.report_project_id == item.id" :key="item.id">{{ item.project }}({{ item.company }})</Tag> -->
          <!-- </Select> -->
        <!-- </FormItem> -->
        <FormItem label="到款金额" prop="report_project_id">
          <report-money :rp-id="Number(form.report_project_id)" :year="''+this.selYear" :month="''+this.selMonth" :visible="formModal"></report-money>
        </FormItem>
        <!-- <FormItem label="合计到款" prop="money">
            <Input v-model="form.money" placeholder="请输入金额" number style="width: 380px">
              <span slot="append"> 元</span>
            </Input>
        </FormItem> -->
      </Form>
    </Modal>
  </div>
</template>

<script>
import {fetch} from '../fetch/api'
// import * as _ from '../util/tools'

export default {
  name: 'ReportFormComponent',
  props: {
  },
  components: {
    ReportMoney: resolve => { require(['./ReportMoney'], resolve) }
  },
  data () {
    var date = new Date()
    var year = String(date.getFullYear())
    var month = date.getMonth()

    return {
      year: year,
      selYear: year,
      selMonth: month,
      formModal: false,
      projectIndex: 0,
      department: '0',
      results: {},
      departmentGroup: [],
      form: {
        id: 0,
        report_project_id: 0,
        year_month: '',
        money: null
      },
      projects: {},
      ruleFormValidate: {
        money: [
          { type: 'number', message: '格式错误请认真输入', trigger: 'blur' }
        ]
      },
      pickerOpen: false
    }
  },
  filters: {
    toMoney (num) {
      if (!num) return '--'
      num = parseFloat(num)
      // num = num.toLocaleString()
      return Number(num).toFixed(2) + ' 元' // 返回的是字符串23,245.12保留2位小数
    },
    formatYear: (val) => {
      var data = new Date(val)
      return data.getFullYear()
    }
  },
  watch: {
    $route (to) {
      let action = to.params.action
      if (action === undefined || action === 'form') {
        this.fetchDepartmentGroup()
      }
    }
  },
  mounted () {
    this.fetchDepartmentGroup()
  },
  methods: {
    dateChange () {
      this.reportProjectYear()
    },
    addForm () {
      // post('console/reportForm', this.form).then(res => {
      //   if (res.status === 'ok') {
      //     this.fetchData()
      //   }
      //   this.$Message.info({content: res.msg})
      // })
    },
    getChildren (ind, month) {
      var results = this.results[ind]
      if (!results.children) return false
      for (let k in results.children) {
        // console.log(Number(results.children[k].month), Number(results.children))
        if (Number(results.children[k].month) === Number(month)) {
          return results.children[k]
        }
      }
      return false
    },
    getMoney (ind, month) {
      var res = this.getChildren(ind, month)
      return res ? Number(res.money).toFixed(2) : res
    },
    getSub (ind, month) {
      var res = this.getChildren(ind, month)
      return res ? res.sub : []
    },
    modalVisibleChange (visible) {
      if (!visible) {
        this.fetchData()
        this.form = {
          id: 0,
          report_project_id: 0,
          year_month: '',
          money: ''
        }
      }
    },
    departmentChange () {
      this.fetchData()
    },
    projectChange () {
      this.form.report_project_id = this.projects[this.projectIndex].id
      this.fetchData()
    },
    addMoney (projectId, month) {
      var date = new Date(this.year)
      var year = date.getFullYear()
      this.selYear = year
      this.selMonth = month - 1
      this.form.year_month = year + '-' + month
      this.form.report_project_id = projectId
      this.formModal = true
    },
    editMoney (ind, month) {
      var res = this.getChildren(ind, month)
      var data = new Date(this.year)
      var year = data.getFullYear()
      this.selYear = year
      this.selMonth = month - 1
      this.form = {
        id: res.id,
        report_project_id: res.report_project_id,
        year_month: res.year + '-' + res.month,
        money: res.money
      }
      this.formModal = true
    },
    selectPicker () {
      this.pickerOpen = true
    },
    pickerOk () {
      this.pickerOpen = false
      this.fetchData()
    },
    fetchData () {
      var data = new Date(this.year)
      var year = data.getFullYear()
      fetch(`console/reportCompany/all`, {params: {year: year, department: this.department}}).then(res => {
        if (res.length > 0) {
          var data = res
          for (let k in data) {
            var item = data[k].children
            var total = 0
            for (let l in item) {
              var child = item[l]
              total += Number(child.money)
            }
            data[k].total = total
          }
          // this.project = data
          this.results = data
          // this.form.report_project_id = data[0].id
          this.spinShow = false
        } else {
          // this.project = []
          this.results = {
            children: []
          }
        }
      }).catch(() => {
        this.spinShow = false
      })
    },
    fetchDepartmentGroup () {
      fetch(`console/departmentGroup/all`).then(res => {
        this.departmentGroup = res
        this.department = res[0].id
        this.reportProjectYear()
        this.fetchData()
      })
    },
    reportProjectYear () {
      var data = new Date(this.year)
      var year = data.getFullYear()
      fetch(`console/reportProjectYear/all`, {params: {date: year}}).then(res => {
        this.projects = res
      })
    },
    countMoney () {
      let val = 0
      for (let k in this.results) {
        val += Number(this.results[k].total)
      }
      return val
    }
  }
}
</script>
